import React from 'react';
import {
  Edit,
  ListButton,
  TopToolbar,
  useNotify,
  useRefresh,
} from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import MoralPersonForm from './MoralPersonForm';
import { errors, thereWasProblem } from '../../Utils/messages';

const MoralPersonActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const MoralPersonEdit = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const onFailure = (error) => {
    refresh();

    const code = error.body.data.errorCode;
    notify(
      `${thereWasProblem}: ${
        errors[code] || 'Hubo un error con su solicitud, inténtelo mas tarde...'
      }`,
      'warning'
    );
  };

  return (
    <Edit
      actions={<MoralPersonActions {...props} />}
      onFailure={onFailure}
      {...props}
    >
      <MoralPersonForm />
    </Edit>
  );
};

export default MoralPersonEdit;
